enum PlatformValues {
  STV = 'Beeswax',
  YouTube = 'YouTube',
  Audio = 'Audio',
  DOOH = 'DOOH',
  Simplifi = 'Simplifi',
  GAM = 'GAM',
}

export default PlatformValues;
